import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/subscriptions/cancel.ts
import { Exception } from "@wbk/logger";
import { getLocaleOnly } from "@wbk/utils";
var cancelSubscription = (_0) => __async(void 0, [_0], function* ({
  subscriptionId,
  planId,
  locale,
  reason,
  other
}) {
  var _a;
  try {
    const lang = getLocaleOnly(locale);
    const data = yield fetchClient({
      url: `subscriptions/cancel-subscription-plan?lang=${lang}`,
      options: {
        method: "POST",
        body: JSON.stringify({
          subscription_plan_id: planId,
          lang,
          reason,
          other
        })
      }
    });
    if (((_a = data.status) == null ? void 0 : _a.toLowerCase()) !== "success") {
      throw new Error(`Failed to cancel subscription plan: ${planId}`);
    }
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "cancelSubscriptionPlanException",
      context: { tags: { journey: "subscribe" }, extra: { subscriptionId, planId } }
    });
  }
});

export {
  cancelSubscription
};
//# sourceMappingURL=chunk-DRIP5NSH.mjs.map